import React from 'react';
import { RichText } from 'prismic-reactjs';
import {MetaTags} from "react-meta-tags";
const Elements = RichText.Elements;


let firebaseProduction = {
	apiKey: "AIzaSyAZUB6GaWQqPTFROrs6o0HV8FFysh4pOj4",
	authDomain: "videosforchange-production.firebaseapp.com",
	databaseURL: "https://videosforchange-production.firebaseio.com",
	projectId: "videosforchange-production",
	storageBucket: "videosforchange-production.appspot.com",
	messagingSenderId: "676666473629",
	storageURL:"https://firebasestorage.googleapis.com/v0/b/videosforchange-production.appspot.com/o/"
}
let firebaseStaging = {
	apiKey: "AIzaSyCKzmEULLCK8RHGKfhnOtGQ7BMw-R4SzeM",
	authDomain: "videosforchange-staging.firebaseapp.com",
	databaseURL: "https://videosforchange-staging.firebaseio.com",
	projectId: "videosforchange-staging",
	storageBucket: "videosforchange-staging.appspot.com",
	messagingSenderId: "676666473629",
	storageURL:"https://firebasestorage.googleapis.com/v0/b/videosforchange-staging.appspot.com/o/"
}
export const firebaseConfig = (process.env.NODE_ENV === 'production' ? firebaseProduction : firebaseStaging);

export const propsWithUniqueKey = function(props, key) {
	return Object.assign(props || {}, { key });
  };

export const PrismicConfig = {
	apiEndpoint: 'https://videosforchange.prismic.io/api/v2',
	linkResolver: function(document, ctx) {
		switch(document.link_type) {
			case 'Document':
			switch(document.type) {
				case 'page':
				return `/page/${document.uid}/`;
				
				default:
				return '/'
			}
			default:
			return '/';
		}
	},
	htmlSerializer : function(type, element, content, children, key) {
		var props = {};
		switch(type) {
			
			// Add a class to paragraph elements
			// case Elements.paragraph:
			// props = {className: 'paragraph-class'};
			// return React.createElement('p', propsWithUniqueKey(props, key), children);
			
			// Don't wrap images in a <p> tag
			case Elements.image: 
			// console.log('e',element);
			props = { src: element.url , alt: element.alt || '', style: {width: element.dimensions.width}, className : "content-image"};
			let img = React.createElement('img', propsWithUniqueKey(props, key));
			// console.log('img',img);
			if(element.linkTo && element.linkTo.url) {
				img = React.createElement('a', propsWithUniqueKey({href:element.linkTo.url, target:element.linkTo.target}, key), img)
				// console.log('linked',img);
			}
			return img;

      case Elements.hyperlink:
      	if (element.linkType === 'anchor') {
          return React.createElement("a", propsWithUniqueKey({id: element.name, name: element.name}, key), "");
				}
				return null;


      // Add a class to hyperlinks
			// case Elements.hyperlink:
			// const targetAttr = element.data.target ? { target: element.data.target } : {};
			// const relAttr = element.data.target ? { rel: 'noopener' } : {};
			// props = Object.assign({
			// 	className: 'link-class',
			// 	href: element.data.url || linkResolver(element.data)
			// }, targetAttr, relAttr);
			// return React.createElement('a', propsWithUniqueKey(props, key), children);
			
			// Return null to stick with the default behavior
			default: 
			return null;
		}
	}
};

export const googleAnalytics = {
	account: "UA-25422525-2"
};

export const stateOptions = {
	vic: "Victoria",
	nsw: "New South Wales",
	sa: "South Australia",
	qld: "Queensland",
	tas: "Tasmania",
	wa: "Western Australia",
	act: "Australian Capital Territory",
	nt: "Northern Territory"
};

export const competitionStates = {
	open: "Open",
	closed: "Closed",
	voting: "Voting",
	winners: "Winners"
};

export const ageOptions = {
	under18: "Under 18",
	over18: "Over 18"
};

export const genderOptions = {
	male: "Male",
	female: "Female",
	other: "Other"
};
export const gradeOptions = {
	grade7: "7",
	grade8: "8",
	grade9: "9",
	grade10: "10",
	grade11: "11",
	grade12: "12"
};


export const socialIssueOptions = {
	agedcare:"Aged Care",
	animalwelfare:"Animal welfare",
	biodiversity:"Biodiversity",
	bodyimage:"Body Image",
	bullying:"Bullying",
	childandmaternalhealth:"Child and Maternal Health",
	climatechange:"Climate Change",
	consumerism:"Consumerism",
	depression:"Depression",
	disabilitydiscrimination:"Disability Discrimination",
	domesticviolence:"Domestic Violence",
	drugalcoholabuse:"Drug & Alcohol Abuse",
	educationaccessandreimagining:"Education- Access and Reimagining",
	environment:"Environment",
	foodwastesustainability:"Food waste/Sustainability",
	genderinequality:"Gender Inequality",
	healthylifestyle:"Healthy Lifestyle",
	homelessness:"Homelessness",
	humantrafficking:"Human trafficking",
	indigenousissues:"Indigenous Issues",
	lackofaccesstoeducation:"Lack of Access to Education",
	lgbtiqrights:"LGBTIQ+ Rights",
	mentalhealth:"Mental health",
	povertyincomeinequality:"Poverty/Income Inequality",
	racism:"Racism",
	recycling:"Recycling",
	refugeesasylumseekers:"Refugees/Asylum seekers",
	selfesteem:"Self Esteem",
	socialexclusion:"Social Exclusion",
	unemploymentfairincome:"Unemployment/Fair Income",
	waterjustice:"Water Justice",
	other:"Other"
};

export const howDidYouHearAboutUsOptions = {
	myschool:"My school",
	afriend:"A friend",
	anexternalyouthgroup:"An external youth group",
	instagram:"Instagram",
	facebook:"Facebook",
	youtube:"YouTube",
	networkten:"Network Ten",
	platypus:"Platypus",
	websearch:"Web search",
	other:"Other",
};

export const categoryOptions = {
	all : "All",
	junior : "Junior",
	senior : "Senior"
};

export const voteModalTextPageUID = 'vote-modal-text';
export const castYourVoteTextPageUID = 'cast-your-vote-text';

export const voteLimit = 6;

export const redirects = [
	{short: '/vote', real: '/competition/2019'},
	{short: '/global', real: '/page/global-page'},
	{short: '/info', real: '/page/info'},
	{short: '/resources', real: '/page/resources'},
	{short: '/videos', real: '/page/videos'},
	{short: '/summit', real: '/page/summit'},
	{short: '/enter', real: '/competition/2019'},
]

export const defaultMetaImage = "https://videosforchange.cdn.prismic.io/videosforchange/df4a07c8-23cc-4905-a46b-dbc2c965fd04_2018+finalists+give+us+one+min+final.jpg"
export const defaultMetaImageWidth = 1186
export const defaultMetaImageHeight = 610
export const DefaultMetaTags = ({title}) => (<MetaTags>
	<meta property="og:type" content="website" />
	<meta property="og:title" content={title} />
	<meta property="og:url" content={window.location.href} />
	<meta property="og:image" content={defaultMetaImage} />
	<meta property="og:image:width" content={defaultMetaImageWidth} />
	<meta property="og:image:height" content={defaultMetaImageHeight} />
	<meta property="og:description" content="To vote, register first! This will allow you to select your favourites. Once you’re done, click the button at the bottom of the page to submit your votes. You can select up to 6 videos." />
	<meta property="og:site_name" content="Videos for Change" />
</MetaTags>)


export const validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


// WEBPACK FOOTER //
// ./src/config.js